<script setup>
import { useTimeout } from "vutil";
import { ref } from "vue";

const props = defineProps(["value"]);

const tmr = useTimeout(() => (copied.value = false));
const copied = ref(false);

async function copy()
{
	await navigator.clipboard.writeText(props.value);
	copied.value = true;
	tmr.set(2000);
}
</script>

<template>
	<button class="ui icon" title="Copy" @click="copy">
		<img :class="copied ? 'icon-clipboard-check' : 'icon-clipboard'"/>
	</button>
</template>
